module.exports = __webpack_public_path__ + "static/media/pattern4.b6ff4446.svg";